<p>
  close-current-tab works!
</p>
